// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useEffect, useRef} from 'react';
import zurl from 'zurl';
import {Editor} from '../../../shared/editor/editor';
import gtm from '../gtm';
// @ts-ignore
import {download_file, track_download} from '../install_util.js';
// @ts-ignore
import {get_exe_link} from '../install_links.js';

const page_view_sent = new Set<string>();

interface i_iframe_props {
    iframe_src?: string;
    page_name?: string;
    campaign?: string;
    download_url?: string;
}

export const Lp_iframe_template = (props: i_iframe_props)=>{
    const iframe_src = props.iframe_src || '/templates/landing-hola.html';
    const page_name = props.page_name || 'landing-hola';
    const qs_o = zurl.qs_parse(window.location.search.substr(1),
        {safe: true});
    const campaign = qs_o.campaign || props.campaign || 'intg5';
    const [height, set_height] = useState(600);
    const content_h = useRef(600);
    useEffect(()=>{
        const pv_key = page_name+'|'+window.location.pathname;
        if (!page_view_sent.has(pv_key))
        {
            page_view_sent.add(pv_key);
            gtm.push({event: 'page_view', page_name,
                page_path: window.location.pathname});
        }
        function apply_height(){
            set_height(Math.max(content_h.current, window.innerHeight));
        }
        function on_msg(e: MessageEvent){
            if (!e.data)
                return;
            if (e.data.type==='lp_height')
            {
                content_h.current = e.data.height;
                apply_height();
            }
            if (e.data.type==='lp_event')
                gtm.push(Object.assign({page_name}, e.data.payload));
            if (e.data.type==='lp_cta')
            {
                const link = get_exe_link({has_svc: false, svc_info: false,
                    mac_installer: false, after_dl_flow: true, campaign});
                track_download({url: link, origin_name: 'download_lp_vpn8'});
                download_file(link);
            }
        }
        window.addEventListener('message', on_msg);
        window.addEventListener('resize', apply_height);
        return ()=>{
            window.removeEventListener('message', on_msg);
            window.removeEventListener('resize', apply_height);
        };
    }, [page_name, campaign]);
    const src = 'https://hola.org/www/hola/pub'+iframe_src
        +(iframe_src.indexOf('?')<0 ? '?' : '&')
        +'campaign='+encodeURIComponent(campaign);
    return <section style={{width: '100%', margin: 0, padding: 0}}>
      <iframe src={src} title="Marketing template"
        scrolling="no"
        style={{width: '100%', height: height+'px', border: 'none',
          display: 'block'}}/>
    </section>;
};

export const Lp_iframe_template_editor = (props: any)=>{
    const [state, set_state] = useState(props.value || {});
    return <Editor
      value={state}
      editors={[
        {key: 'iframe_src', label: 'Iframe URL', type: 'text'},
        {key: 'page_name', label: 'Page name', type: 'text'},
        {key: 'campaign', label: 'Campaign ID', type: 'text'},
        {key: 'download_url', label: 'Download URL', type: 'text'},
      ]}
      on_change={(v: any)=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};
